module.exports = __webpack_public_path__ + "img/g8.2b9185c7.png";